export default "__VITE_ASSET__Dtf0iybt__"